import axiosInstance from '@/shared/api/axios';
import type { ApiPinflGetResponse } from '@/shared/types/api/pinfl';

export const apiPinflGet = async (
  pinfl: string,
  excludeParcel?: string,
): Promise<ApiPinflGetResponse> => {
  const { data } = await axiosInstance.get<ApiPinflGetResponse>(`/pinfl/${pinfl}`, {
    params: excludeParcel ? { exclude_parcel: excludeParcel } : undefined,
  });
  return data;
};
